<template>
    <NavbarMain :first-page="true" />
    <div v-if="loading">Loading...</div>

    <div v-else>

        <BannerFirstPage :banner_image="banner_image_en" :banner_title="banner_title_en"
            :banner_button_text="banner_button_text_en" :banner_button_link="banner_button_link_en" />

        <ContentWithPhoto :content-photo_image="first_section_image_en" :content-photo_title="first_section_title_en"
            :content-photo_content1="first_section_content_en" :content-photo_content2="first_section_content2" />

        <div class="columns-4-section">

            <PhotoCardsHeader :section_title="second_section_title_en"
                :section_content="second_section_content_en" />


            <PhotoCards :section_image="second_section_image_en" :button_title="second_section_title_en"
                :button_text="second_section_button_text_en" :button_link="second_section_button_link_en" />
        </div>
        <br />

        <WidePhotoComponent :photo="third_section_banner_image_en" :content="third_section_banner_title_en" />

        <div class="columns-6-section">

            <CardSection :content-title="fourth_section_title_box_one_en"
                :content-sentance="fourth_section_content_box_one_en" />


            <CardSection :content-title="fourth_section_title_box_two_en"
                :content-sentance="fourth_section_content_box_two_en" />

            <CardSection :content-title="fourth_section_title_box_three_en"
                :content-sentance="fourth_section_content_box_three_en" />
        </div>

    </div>


    <CookieWarningView />
    <FooterPage />
</template>

<script>
import axios from 'axios';

import BannerFirstPage from '@/components/BannerFirstPage.vue';
import FooterPage from '@/components/FooterPage.vue';
import NavbarMain from '@/components/NavbarMain.vue';
import WidePhotoComponent from '@/components/WidePhotoComponent.vue';
import ContentWithPhoto from '@/components/ContentWithPhoto.vue'
import CardSection from '@/components/CardSection.vue'
import PhotoCards from '@/components/PhotoCards.vue';
import CookieWarningView from './CookieWarningView.vue';
import PhotoCardsHeader from '@/components/PhotoCardsHeader.vue';

export default {
    components: {
        NavbarMain,
        BannerFirstPage,
        WidePhotoComponent,
        FooterPage,
        ContentWithPhoto,
        CardSection,
        PhotoCards,
        PhotoCardsHeader,
        CookieWarningView
    },
    data() {
        return {
            loading: true, // Add loading state

            homepageData: { items_en: [{}] },

            id_en: '', page_name_en: '',
            banner_image_en: '', banner_title_en: '', banner_button_text_en: '', banner_button_link_en: '',
            first_section_image_en: '', first_section_title_en: '', first_section_content_en: '',
            second_section_image_en: '', second_section_title_en: '', second_section_content_en: '', second_section_button_text_en: '', second_section_button_link_en: '',
            third_section_banner_image_en: '', third_section_banner_title_en: '', third_section_banner_button_text_en: '', third_section_banner_button_link_en: '',
            fourth_section_title_box_one_en: '', fourth_section_content_box_one_en: '', fourth_section_button_box_one_en: '', fourth_section_button_link_box_one_en: '',
            fourth_section_title_box_two_en: '', fourth_section_content_box_two_en: '', fourth_section_button_box_two_en: '', fourth_section_button_link_box_two_en: '',
            fourth_section_title_box_three_en: '', fourth_section_content_box_three_en: '', fourth_section_button_box_three_en: '', fourth_section_button_link_box_three_en: '',

            // Referenced by the template but not provided by the API; kept empty.
            first_section_content2: '',
        }
    },
    methods: {
        fetchData() {
            const token = process.env.VUE_APP_WEBSITE_TOKEN;
            const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

            axios.get(`${API_URL}/api/home-content`, {
                headers: {
                    'Authorization': `Token ${token}`,
                },
            })
                .then(response => {
                    this.homepageData = response.data || { items_en: [] };

                    if (this.homepageData.items_en[0]?.active === true) {
                        this.id_en = this.homepageData.items_en[0].id;
                        this.page_name_en = this.homepageData.items_en[0].page_name;

                        this.banner_image_en = this.homepageData.items_en[0].banner_image;
                        this.banner_title_en = this.homepageData.items_en[0].banner_title;
                        this.banner_button_text_en = this.homepageData.items_en[0].banner_button_text;
                        this.banner_button_link_en = this.homepageData.items_en[0].banner_button_link;

                        this.first_section_image_en = this.homepageData.items_en[0].first_section_image;
                        this.first_section_title_en = this.homepageData.items_en[0].first_section_title;
                        this.first_section_content_en = this.homepageData.items_en[0].first_section_content;

                        this.second_section_image_en = this.homepageData.items_en[0].second_section_image;
                        this.second_section_title_en = this.homepageData.items_en[0].second_section_title;
                        this.second_section_content_en = this.homepageData.items_en[0].second_section_content;
                        this.second_section_button_text_en = this.homepageData.items_en[0].second_section_button_text;
                        this.second_section_button_link_en = this.homepageData.items_en[0].second_section_button_link;

                        this.third_section_banner_image_en = this.homepageData.items_en[0].third_section_banner_image;
                        this.third_section_banner_title_en = this.homepageData.items_en[0].third_section_banner_title;
                        this.third_section_banner_button_text_en = this.homepageData.items_en[0].third_section_banner_button_text;
                        this.third_section_banner_button_link_en = this.homepageData.items_en[0].third_section_banner_button_link;

                        this.fourth_section_title_box_one_en = this.homepageData.items_en[0].fourth_section_title_box_one;
                        this.fourth_section_content_box_one_en = this.homepageData.items_en[0].fourth_section_content_box_one;
                        this.fourth_section_button_box_one_en = this.homepageData.items_en[0].fourth_section_button_box_one;
                        this.fourth_section_button_link_box_one_en = this.homepageData.items_en[0].fourth_section_button_link_box_one;
                        this.fourth_section_title_box_two_en = this.homepageData.items_en[0].fourth_section_title_box_two;
                        this.fourth_section_content_box_two_en = this.homepageData.items_en[0].fourth_section_content_box_two;
                        this.fourth_section_button_box_two_en = this.homepageData.items_en[0].fourth_section_button_box_two;
                        this.fourth_section_button_link_box_two_en = this.homepageData.items_en[0].fourth_section_button_link_box_two;
                        this.fourth_section_title_box_three_en = this.homepageData.items_en[0].fourth_section_title_box_three;
                        this.fourth_section_content_box_three_en = this.homepageData.items_en[0].fourth_section_content_box_three;
                        this.fourth_section_button_box_three_en = this.homepageData.items_en[0].fourth_section_button_box_three;
                        this.fourth_section_button_link_box_three_en = this.homepageData.items_en[0].fourth_section_button_link_box_three;
                    }

                    this.loading = false;
                })
                .catch(error => {
                    console.error('Error fetchig Homepage data:', error)
                    this.loading = false;
                });
        }
    },
    created() {
        this.fetchData(); // Move data fetching to the created hook
    },
}
</script>

<style>
body {
    margin-top: 0px;
}

.columns-6-section {
    margin-left: 5%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: auto;
}

@media all and (max-width: 850px) {
    .columns-6-section {
        display: grid;
        grid-template-columns: 1fr;
        gap: 10px;
    }
}

.columns-4-section {
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    /* Center the columns horizontally */
    align-items: center;
    gap: 10px;
    padding: auto;
}

@media all and (max-width: 850px) {
    .columns-4-section {
        display: grid;
        grid-template-columns: 1fr;
        gap: 10px;
    }
}
</style>
